module.exports = __webpack_public_path__ + "img/pgd_a_10101.f08a1d0f.png";